import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { gridConfig, tokens } from '../../../../constants';
export var getGridContainerStyles = (props, breakpoint) => {
  var _a;
  var fullWidth = props.fullWidth,
    config = props.config,
    noMargin = props.noMargin;
  var _ref = (config === null || config === void 0 ? void 0 : config[breakpoint]) || {},
    outerMargin = _ref.outerMargin;
  return StyleSheet.create({
    topContainer: {
      flexDirection: 'row',
      justifyContent: 'center'
    },
    rowContainer: Object.assign(Object.assign({
      flex: 1
    }, !fullWidth && {
      maxWidth: config === null || config === void 0 ? void 0 : config.containerMaxWidth
    }), !noMargin && {
      marginHorizontal: (_a = tokens.spacing) === null || _a === void 0 ? void 0 : _a[outerMargin]
    })
  });
};
export var getGridContainerProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var _ref2 = merge(gridConfig === null || gridConfig === void 0 ? void 0 : gridConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.grid) === null || _a === void 0 ? void 0 : _a[theme]) || {},
    config = _ref2.config,
    container = _ref2.container;
  return Object.assign(Object.assign({
    theme,
    config
  }, container), props);
};